import { render, staticRenderFns } from "./ProfileLocation.vue?vue&type=template&id=b88c1a20&"
import script from "./ProfileLocation.vue?vue&type=script&lang=js&"
export * from "./ProfileLocation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLocation.vue?vue&type=style&index=0&id=b88c1a20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports